var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",staticStyle:{"background":"var(--bg3)"}},[_c('div',{staticClass:"flex-wrap flex-between",staticStyle:{"height":"40px","padding":"0 10px","border-bottom":"1px solid var(--border)"}},[_c('div',{staticStyle:{"font-weight":"bold"}},[_vm._v("服务器预警信息")]),_c('div')])])
}]

export { render, staticRenderFns }